import axios from '../axios'

export const selectByPage = (data) => {
    return axios({
        url: '/admin/versionLog/selectByPage',
        method: 'post',
        data
    })
}

export const insert = (data) => {
    return axios({
        url: '/admin/versionLog/insert',
        method: 'post',
        data
    })
}

export const update = (data) => {
    return axios({
        url: '/admin/versionLog/update',
        method: 'post',
        data
    })
}

export const batchDelete = (data) => {
    return axios({
        url: '/admin/versionLog/batchDelete',
        method: 'post',
        data
    })
}

export const batchEnable = (data) => {
    return axios({
        url: '/admin/versionLog/batchEnable',
        method: 'post',
        data
    })
}

export const batchDisabled = (data) => {
    return axios({
        url: '/admin/versionLog/batchDisabled',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/versionLog.js